import {RecordForm} from '../forms/RecordForm';


import {useApplication} from '../hooks/useApplication.ts';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {
    FormPageLayout,
    SimplePageContentWrapper
} from "@flexinet/ui-components";


export const AddPage = () => {

    const {
        createRecord,
    } = useApplication();

    return (
        <FormPageLayout
            title='Add Application'
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordForm handleSubmit={createRecord}/>
            </SimplePageContentWrapper>
        </FormPageLayout>
    );
};
